import React, { useEffect, useState } from "react";
import useAuth from "../hooks/auth/useAuth";
import { useNavigate } from "react-router-dom";
import "../styles/pages/signin.css";
import { authContextType } from "../@types/auth-types";
import Input from "../components/input";
import StatusModal from "../components/status-modal";
import { useApiStatus } from "../hooks/status/useApiStatus";
import { exit } from "process";

//pagina de login
export default function Signin() {
  const { signin, studentSignin } = useAuth() as authContextType;
  const navigate = useNavigate();

  const { data, isSuccess, isError } = useApiStatus();
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const images = ["img1.png", "img2.png", "img3.png"];
  const [activeImage, setActiveImage] = useState(0);

  const [studentCode, setStudentCode] = useState("");

  const [normalUser, setNormalUser] = useState(true);
  const [buttonText, setButtonText] = useState("Sou aluno");

  const handleLogin = () => {
    console.log(normalUser);
    if (!normalUser) {
      handleStudentLogin();
      return;
    }

    if (!email || !password) {
      setError("Preencha todos os campos");
      return;
    }

    signin(email, password)
      .then((res) => {
        console.log(res);
        navigate("/auth");
      })
      .catch((error) => {
        setError(error);
      });
    //passar para o react query
  };

  const handleStudentLogin = () => {
    if (!studentCode) {
      setError("Preencha o campo do código do aluno");
      return;
    }

    studentSignin(studentCode)
      .then((res) => {
        console.log(res);
        navigate("/home");
      })
      .catch((error) => {
        setError(error);
      });

    //passar para o react query
  };

  const handleChangeLogin = () => {
    setEmail("");
    setPassword("");
    setStudentCode("");

    if (normalUser) {
      setNormalUser(false);
      setButtonText("Sou instituição");
    } else {
      setNormalUser(true);
      setButtonText("Sou aluno");
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveImage(
        (prevActiveImage) => (prevActiveImage + 1) % images.length
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isError || data?.status === "offline") {
      setIsStatusModalOpen(true);
    } else {
      setIsStatusModalOpen(false);
    }
  }, [isSuccess, isError, data]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        handleLogin();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [email, password]);

  return (
    <div className="background-signin">
      <div className="background-left-signin">
        <img
          src={require(`../assets/login/${images[activeImage]}`)}
          className="left-image-signin"
        />
        <div className="image-options-container-signin">
          <div
            className={
              activeImage == 0
                ? "image-option-selected-signin"
                : "image-option-signin"
            }
          ></div>
          <div
            className={
              activeImage == 1
                ? "image-option-selected-signin"
                : "image-option-signin"
            }
          ></div>
          <div
            className={
              activeImage == 2
                ? "image-option-selected-signin"
                : "image-option-signin"
            }
          ></div>
        </div>
        <img
          src={require("../assets/login/institution-logo.png")}
          alt="Logo das instituição parceiras do projeto"
          className="institution-logo-signin"
        />
      </div>
      <div className="background-right-signin">
        <div className="content-signin">
          <img
            src={require("../assets/logo-azul.png")}
            className="logo-image-signin"
          />

          {normalUser ? (
            <>
              <Input
                label="Email"
                name="email"
                type="email"
                placeholder="exemplo@gmail.com"
                onChange={(e: React.FormEvent) => [
                  setEmail((e.target as HTMLInputElement).value),
                  setError(""),
                ]}
              />
              <Input
                label="Senha"
                name="password"
                type="password"
                placeholder=" "
                onChange={(e: React.FormEvent) => [
                  setPassword((e.target as HTMLInputElement).value),
                  setError(""),
                ]}
              />
            </>
          ) : (
            <>
              <Input
                label="CÓDIGO DO ALUNO"
                name="code"
                type="code"
                placeholder="DIGITE O SEU CÓDIGO"
                onChange={(e: React.FormEvent) => [
                  setStudentCode((e.target as HTMLInputElement).value),
                  setError(""),
                ]}
              />
            </>
          )}

          <label className="label-error-signin">{error}</label>

          <div className="buttons-container-signin">
            <input
              type="submit"
              value="Entrar"
              className="button-signin"
              onClick={handleLogin}
            ></input>
            <input
              type="submit"
              value={buttonText}
              className="button-signin"
              onClick={handleChangeLogin}
            ></input>
          </div>
        </div>
      </div>
      <StatusModal isOpen={isStatusModalOpen} onOK={() => console.log("ok")} />
    </div>
  );
}
